import React from 'react'

import {Layout, Tooltip, Modal, Form, Input } from 'antd'
import {Icon} from 'antd'
import {Divider} from 'antd'
import 'react-splitter-layout/lib/index.css'
import './photos.css'
import _ from 'lodash'
import Map from './Map'
import ModalCarousel from './ModalCarousel'
import photoService from '../services/shared.photo.service'
import fileDownloadService from '../services/file.download.service'
import SmallPhoto from './SmallPhoto'
import SharedLoginModal from "../commons/SharedLoginModal";
import PublicLayout from "../layout/PublicLayout";

const { Content, Sider } = Layout

class SharedPhotosView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: true,
      loadingTree: true,
      treeData: [],
      selectedFolder: {
        _id: null,
      },
      modal: {
        visible: false,
        action: null,
        data: [],
      },
      photos: [],
      folderPath: 'Photos',
      expandedKeys: [],
      mapOn: false,
      selectedPhotos: [],
      users: [],
      carouselVisible: false,
      token: null,
      showLoginModal: true,
    }
    this.upload = null
    this.ctrlKey = false
    this.selectedFolderName = ''
    this.currentTreeAction = ''
    this.smallPhotos = {}
    this.map = {}
    this.formRef = React.createRef()
  }

  getSelectedPhotoIndex = () => {
    if (this.state.selectedPhotos.length == 1) {
      const selected = this.state.selectedPhotos[0].props.file
      return _.findIndex(this.state.photos, p => p._id == selected._id)
    }
    return 0
  }

  removeHighlight = () => {
    this.state.selectedPhotos.forEach(c => c.setHighlight(false))
    this.state.selectedPhotos = []
  }

  handleOnSelectPhoto = component => {
    if (!this.ctrlKey) {
      this.removeHighlight()
    }
    component.setHighlight(true)
    this.state.selectedPhotos.push(component)
    this.setState({ selectedPhotos: this.state.selectedPhotos })
    if (this.state.mapOn) {
      this.map.addMarkerAnimation(component.props.file._id)
    }
  }

  handleDownload = () => {
    if (this.state.selectedPhotos.length == 1) {
      const file = this.state.selectedPhotos[0].props.file
      const url = `/api/v1/share/photos/file/download/?fileId=${file._id}&folderPath=${this.state.folderPath}`
      window.open(url);
      //fileDownloadService.download(url, file.originalname)
    }
  }

  handleOnClickOnMapMarker = photoId => {
    const component = this.smallPhotos[photoId]
    this.handleOnSelectPhoto(component)
  }

  showMap = () => {
    const mapOn = this.state.mapOn
    const collapsed = this.state.collapsed
    if (collapsed && mapOn) {
      console.log('something is wrong. This should never happen!!!')
    }
    if ((collapsed && !mapOn) || (!collapsed && mapOn)) {
      this.setState({
        mapOn: !mapOn,
        collapsed: !collapsed,
      })
    }
    if (!collapsed && !mapOn) {
      this.setState({
        mapOn: true,
      })
    }
  }

  componentDidMount() {
      console.log("location:", this.props.location.pathname);
      const pathname = this.props.location.pathname;
      const idx = pathname.lastIndexOf('/');
      const token = pathname.substr(idx + 1);
      console.log("token:", token);
      this.setState({
         token: token
      });
      this.loadPhotos(token)
  }

  loadPhotos(token, jwt) {
      photoService.getPhotos(token, jwt).then((photos) => {
          this.setState({photos: photos});
      }).
      catch( error => {
          this.setState({error: error})
      })
  }

  renderPhotoContainer = photos => {
    this.smallPhotos = {}
    const list = []
    for (let photo of photos) {
      if ( !photo.displayInSharedLink || photo.displayInSharedLink === "true" ) {
          let smallPhoto = (
              <SmallPhoto
                  key={photo._id}
                  file={photo}
                  onClick={this.handleOnSelectPhoto}
                  onDoubleClick={e => {
                      console.log('double clicking photo', e)
                      this.setState({carouselVisible: true})
                  }}
                  ref={e => {
                      this.smallPhotos[photo._id] = e
                  }}
                  shared={true}
                  token={this.state.token}
              />
          )
          list.push(smallPhoto)
      }
    }
    return list
  }

  login = (username, password) => {
      photoService.login(username, password)
          .then( rsp => {
              console.log('login rsp:', rsp)
              this.setState({showLoginModal: false, error: null})
              this.loadPhotos(this.state.token, rsp.jwt)
          })
          .catch(err =>{
              this.setState({error: err, showLoginModal: false})
          })
  }

  render() {
      if ( this.state.error && this.state.error.message === "401"){
          return (
              <PublicLayout>
                  <SharedLoginModal visible={this.state.showLoginModal} onSubmit={this.login} onCancel={() => {
                      this.setState({showLoginModal: false})
                  }}/>
              </PublicLayout>
          )
      }

    return (
    <PublicLayout>
        { this.state.photos.length > 0 ?
            <div
                style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column', padding: '0px 30px'}}
            >
              <div style={{marginRight:'16px'}}>
                <div
                    style={{
                        display: 'inline',
                        float: 'right',
                        marginTop: '15px',
                        marginLeft: '10px',
                        marginBottom: '15px'
                    }}
                >
                  <Tooltip placement="bottom" title={'Download photo'}>
                    <Icon
                        type="download"
                        onClick={this.handleDownload}
                        style={{
                            marginLeft: '20px',
                            fontSize: '18px',
                            paddingTop: '10px',
                        }}
                    />
                  </Tooltip>
                </div>
                <div style={{display: 'inline', float: 'right', marginTop: '15px'}}>
                  <Tooltip placement="bottom" title={'Show maps'}>
                    <Icon
                        type="global"
                        onClick={this.showMap}
                        style={{
                            marginLeft: '20px',
                            fontSize: '18px',
                            paddingTop: '10px',
                        }}
                    />
                  </Tooltip>
                </div>
                <Divider style={{margin: '0px'}}/>
              </div>
              <div style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column'}}>
                <div
                    id="photoContainer"
                    style={{
                        flex: '1 1 auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                  <Layout>
                    <Content>
                      <div
                          onKeyDown={e => {
                              this.ctrlKey = e.ctrlKey
                          }}
                          onKeyUp={e => {
                              this.ctrlKey = e.ctrlKey
                          }}
                          tabIndex="0"
                          style={{
                              flex: '1 1 auto',
                              overflow: 'auto',
                              height: '100px'
                          }}
                      >
                          {this.renderPhotoContainer(this.state.photos)}
                      </div>
                    </Content>

                    <Sider
                        trigger={null}
                        collapsible
                        collapsed={this.state.collapsed}
                        style={{background: '#fff'}}
                        width={460}
                        collapsedWidth={0}
                    >
                      <div style={{padding: '5px'}}>
                          {!this.state.collapsed && this.state.mapOn ? (
                              <Map
                                  photos={this.state.photos}
                                  folderId={this.state.selectedFolder._id}
                                  onClickOnMarker={this.handleOnClickOnMapMarker}
                                  ref={e => {
                                      this.map = e
                                  }}
                              />
                          ) : null}
                      </div>
                    </Sider>
                  </Layout>
                </div>
              </div>
              <ModalCarousel
                  visible={this.state.carouselVisible}
                  photos={this.state.photos}
                  initialSlide={this.getSelectedPhotoIndex()}
                  onCancel={() => {
                      this.setState({carouselVisible: false})
                  }}
                  shared={true}
                  token={this.state.token}
              />
            </div>
            : null
        }
    </PublicLayout>
    )
  }
}

export default SharedPhotosView;
